import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { wait } from "../../utils/utils";
import { poll } from "../../../utils/fn";
import { getWindow } from "../../../utils/window";
import { DEFAULT_INTERVAL, ECommonStatus, EPollStatus } from "../submitPayment/constants";
import { EPaymentStatusConstant } from "./constants";
export var clearParams = function clearParams(params) {
  var _getWindow$location$h, _getWindow, _getWindow2;
  var url = new URL((_getWindow$location$h = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.href) !== null && _getWindow$location$h !== void 0 ? _getWindow$location$h : '');
  params.forEach(function (param) {
    return url.searchParams.delete(param);
  });
  (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 || _getWindow2.history.replaceState({
    path: url.toString()
  }, '', url.toString());
};
var clearTopupParams = function clearTopupParams() {
  return clearParams([EPaymentStatusConstant.OrderIdParameter, EPaymentStatusConstant.StatusParameter]);
};
export var getUrlParams = function getUrlParams() {
  var _getWindow$location$h2, _getWindow3;
  var url = new URL((_getWindow$location$h2 = (_getWindow3 = getWindow()) === null || _getWindow3 === void 0 ? void 0 : _getWindow3.location.href) !== null && _getWindow$location$h2 !== void 0 ? _getWindow$location$h2 : '');
  return Object.fromEntries(url.searchParams);
};
export var getTopupParams = function getTopupParams() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    shouldKeepParameters = _ref.shouldKeepParameters;
  var params = getUrlParams();
  if (!shouldKeepParameters) clearTopupParams();
  return params;
};
export var getStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(paymentId, sendStatusRequest, pollDelay) {
    var _yield$poll, status;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!pollDelay) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return wait(pollDelay);
        case 3:
          _context.next = 5;
          return poll(function () {
            return sendStatusRequest(paymentId);
          }, function (_ref3) {
            var _status = _ref3.status;
            return ![ECommonStatus.Error, ECommonStatus.Success, EPollStatus.Process].includes(_status);
          }, DEFAULT_INTERVAL);
        case 5:
          _yield$poll = _context.sent;
          status = _yield$poll.status;
          return _context.abrupt("return", status || ECommonStatus.Error);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getStatus(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();